module.exports = __webpack_public_path__ + "static/svh-109c6feffe8ed293f208e783211df992.png";